import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { useShortIdContext } from '@air/provider-short-id';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePublicCameraMakesList } from '~/swr-hooks/filters/usePublicCameraMakesList';

type PublicCameraMakeSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicCameraMakeSelect = memo(({ boardId, ...props }: PublicCameraMakeSelectProps) => {
  const [searchValue, setSearchValue] = useState('');
  const { shortId } = useShortIdContext();

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePublicCameraMakesList({
    search: debouncedSearchValue,
    boardId,
    shortId,
  });

  return (
    <StringSelect
      id="camera-make"
      placeholder="Search for make"
      isSingleSelect={true}
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PublicCameraMakeSelect.displayName = 'PublicCameraMakeSelect';
